import { render } from "./App.vue?vue&type=template&id=48aaa30c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=48aaa30c&lang=css"
import "./App.vue?vue&type=style&index=1&id=48aaa30c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aaa30c"]])

export default __exports__